const inititalState = {
    loading: null,
    tasks: [],
    loggedRevenues: [],
    loggedRevenuesForROI: [],
    averageRevenue: {},
    loggedExpenses: [],
    loggedExpensesForROI: [],
    averageExpense: {},
    revenueById: {},
    expenseById: {},
    revenueAnalysis: {},
    featureFMLinks: [],
    spotifyDataForRevenue: {},
    spotifyDataForROI: {},
    spotifyDataForAnalysis: {},
    spotifyDataForForecast: {},
    youtubeDataForRevenue: {},
    youtubeDataForROI: {},
    youtubeDataForAnalysis: {},
    youtubeDataForForecast: {},
    streamingStore: [],
    
}

const artistManagerReducer = (state = inititalState, action) => {
    switch (action.type) {
        case 'STARTCREATETASK':
            return {
                ...state,
                loading: true,
            };
        case 'CREATETASKFAIL':
            return {
                ...state,
                loading: null,
            };
        case 'STARTUPDATETASK':
            return {
                ...state,
                loading: true,
            };
        case 'UPDATETASKFAIL':
            return {
                ...state,
                loading: null,
            };
        case 'STARTGETTASK':
            return {
                ...state,
                loading: true,
            };
        case 'GETTASKFAIL':
            return {
                ...state,
                loading: null,
            };
        case 'TASKDATA':
            return {
                ...state,
                loading: null,
                tasks: action.tasks
            };
        case 'STARTCREATELOGREVENUE':
            return {
                ...state,
                loading: true,
            };
        case 'CREATELOGREVENUEFAIL':
            return {
                ...state,
                loading: null,
            };
        case 'STARTUPDATELOGREVENUE':
            return {
                ...state,
                loading: true,
            };
        case 'UPDATELOGREVENUEFAIL':
            return {
                ...state,
                loading: null,
            };
        case 'STARTGETLOGREVENUE':
            return {
                ...state,
                loading: true,
            };
        case 'GETLOGREVENUEFAIL':
            return {
                ...state,
                loading: null,
            };
        case 'LOGREVENUEDATA':
            return {
                ...state,
                loading: null,
                loggedRevenues: action.loggedRevenues
            };
        case 'LOGREVENUEDATAFORROI':
            return {
                ...state,
                loading: null,
                loggedRevenuesForROI: action.loggedRevenuesForROI
            };
        case 'LOGREVENUEAVERAGE':
            return {
                ...state,
                loading: null,
                averageRevenue: action.averageRevenue
            };
        case 'LOGREVENUEBYIDDATA':
            return {
                ...state,
                loading: null,
                revenueById: action.revenueById
            };
        case 'STARTCREATELOGEXPENSE':
            return {
                ...state,
                loading: true,
            };
        case 'CREATELOGEXPENSEFAIL':
            return {
                ...state,
                loading: null,
            };
        case 'STARTUPDATELOGEXPENSE':
            return {
                ...state,
                loading: true,
            };
        case 'UPDATELOGEXPENSEFAIL':
            return {
                ...state,
                loading: null,
            };
        case 'STARTGETLOGEXPENSE':
            return {
                ...state,
                loading: true,
            };
        case 'GETLOGEXPENSEFAIL':
            return {
                ...state,
                loading: null,
            };
        case 'LOGEXPENSEDATA':
            return {
                ...state,
                loading: null,
                loggedExpenses: action.loggedExpenses
            };
        case 'LOGEXPENSEDATAFORROI':
            return {
                ...state,
                loading: null,
                loggedExpensesForROI: action.loggedExpensesForROI
            };
        case 'LOGEXPENSEBYIDDATA':
            return {
                ...state,
                loading: null,
                expenseById: action.expenseById
            };
        case 'LOGEXPENSEAVERAGE':
            return {
                ...state,
                loading: null,
                averageExpense: action.averageExpense
            };
        case 'STARTREVENUEANALYSIS':
            return {
                ...state,
                loading: true,
            };
        case 'REVENUEANALYSISFAIL':
            return {
                ...state,
                loading: null,
            };
        case 'REVENUEANALYSISDATA':
            return {
                ...state,
                loading: null,
                revenueAnalysis: action.revenueAnalysis
            };
        case 'STARTFETCHFEATUREFMLINKS':
            return {
                ...state,
                loading: null,
            }
        case 'FETCHFEATUREFMLINKSFAIL':
            return {
                ...state,
                loading: null,
            }
        case 'FETCHFEATUREFMLINKS':
            return {
                ...state,
                loading: null,
                featureFMLinks: action.featureFMLinks
            }
        case 'STARTFETCHSONGSTATSDATA':
            return {
                ...state,
                loading: null,
            }
        case 'FETCHSONGSTATSDATAFAIL':
            return {
                ...state,
                loading: null,
            }
        case 'FETCHSPOTIFYDATAFORREVENUE':
            return {
                ...state,
                loading: null,
                spotifyDataForRevenue: action.spotifyDataForRevenue
            }
        case 'FETCHSPOTIFYDATAFORROI':
            return {
                ...state,
                loading: null,
                spotifyDataForROI: action.spotifyDataForROI
            }
        case 'FETCHSPOTIFYDATAFORANALYSIS':
            return {
                ...state,
                loading: null,
                spotifyDataForAnalysis: action.spotifyDataForAnalysis
            }
        case 'FETCHSPOTIFYDATAFORFORECAST':
            return {
                ...state,
                loading: null,
                spotifyDataForForecast: action.spotifyDataForForecast
            }
        case 'FETCHYOUTUBEDATAFORREVENUE':
            return {
                ...state,
                loading: null,
                youtubeDataForRevenue: action.youtubeDataForRevenue
            }
        case 'FETCHYOUTUBEDATAFORROI':
            return {
                ...state,
                loading: null,
                youtubeDataForROI: action.youtubeDataForROI
            }
        case 'FETCHYOUTUBEDATAFORANALYSIS':
            return {
                ...state,
                loading: null,
                youtubeDataForAnalysis: action.youtubeDataForAnalysis
            }
        case 'FETCHYOUTUBEDATAFORFORECAST':
            return {
                ...state,
                loading: null,
                youtubeDataForForecast: action.youtubeDataForForecast
            }
        case 'GETSTREMINGSTORE':
            return {
                ...state,
                streamingStore: action.list
            }     
        default:
            return state;
    }
}

export default artistManagerReducer;